// @flow
import i18n from 'i18n-js';

export const BUS_ARRIVALS = 'trips_entry_exits';
export const ASSISTANCE_PER_TRIP = 'route_assitance';
export const STUDENT_LIST_PER_ROUTE = 'student_list_per_route';
export const CHANGE_STOP_REQUESTS = 'change_stop_requests';
export const CONTACTS_PER_ROUTE = 'contacts_per_route';
export const MONITORS_DRIVERS_LIST = 'monitors_drivers_list';
export const TRIP_COUNT_PER_STUDENT = 'trip_count_per_student';
export const TRIP_STOPS_COMPLETION_TIMES = 'trip_stops_completion_time';

export const getReport = (key?: string) => {
  const REPORT_NAMES = [
    {
      key: BUS_ARRIVALS,
      name: i18n.t('reports.entryExitHours'),
      form_selector: 'student_profile',
      headers: ['# row', 'route tipo', 'Inicio de Ruta', 'Llegada a parada', 'Fin de Ruta', 'trip_stop_name'],
    },
    {
      key: ASSISTANCE_PER_TRIP,
      form_selector: 'route',
      headers: ['Viaje de: Fecha', 'Hora de inicio', 'Abordados', 'No Abordado'],
      name: i18n.t('reports.travelAttendance'),
    },
    {
      key: TRIP_STOPS_COMPLETION_TIMES,
      form_selector: 'route',
      headers: ['Ruta', 'Parada', 'Estudiantes', 'Hora en Parada'],
      name: i18n.t('reports.stopsByTravel'),
    },
    {
      key: STUDENT_LIST_PER_ROUTE,
      form_selector: 'route',
      name: i18n.t('reports.routesStudentList'),
    },
    // {
    //   key: CHANGE_STOP_REQUESTS,
    //   form_selector: 'route',
    //   name: i18n.t('reports.changeStopRequests'),
    // },
  ];
  return key ? REPORT_NAMES.filter(elm => elm.key === key)[0] : REPORT_NAMES;
};



// WEBPACK FOOTER //
// ./src/scripts/components/ReportSidebar/reportConstants.js